angular.module('unergie.main')
.run((FileSelect) => {
    // Hack pour le bug qui empeche de reselectionner le même fichier après l'avoir annulé
    FileSelect.prototype.onChange = function () {
        const files = this.uploader.isHTML5 ? this.element[0].files : this.element[0]
        const options = this.getOptions()
        const filters = this.getFilters()

        if (!this.uploader.isHTML5) {
            this.destroy()
        }
        this.uploader.addToQueue(files, options, filters)
        if (!this.element.attr('multiple')) {
            this.element.prop('value', null)
        }
    }
})
